module.exports = __webpack_public_path__ + "img/mb_logo_top.88a7ea98.png";